import React, { useEffect, useState, useMemo } from 'react';
import Nestable from 'react-nestable';

import MultiSelect from './MultiSelect'

const Applicability = (props) => {
    const [view, setView] = useState(null)
    const [favourites, setFavourites] = useState([])
    const [showOnlyFavourites, setShowOnlyFavourites] = useState(false)
    
    const projectId = props.projectId
    const projectType = props.projectType
    const options = props.options
    const value = props.value
    const onlyAllowOneSystem = props.onlyAllowOneSystem || false

    const onChange = props.onChange
    const disabled = props.disabled
    
    const label = props.label || "Applicability"
    const subLabel = props.subLabel || ""
    const introText = props.introText || "This is applicable to the following Product Tree items."
    const noOptionsText = "There is no Product Tree associated with this " + projectType
    
    const collapse_key = "state_applicability_project_" + projectId
    const nestableRef = React.createRef()

    const view_key = "state_applicability_project_" + projectId + "_view"
    const favourites_key = "state_applicability_project_" + projectId + "_favourites"
    const favourites_only_key = "state_applicability_project_" + projectId + "_favourites_only"
    
    useEffect(() => {
        const view = localStorage[view_key] || "tree"
        setView(view)
    }, [])

    useEffect(() => {
        try {
            const f = JSON.parse(localStorage[favourites_key])
            setFavourites(f)
        } catch(err) {
            localStorage[favourites_key] = JSON.stringify([])
        }
    }, [])
    
    useEffect(() => {
        try {
            const f = JSON.parse(localStorage[favourites_only_key])
            setShowOnlyFavourites(f)
        } catch(err) {
            localStorage[favourites_only_key] = JSON.stringify(false)
        }
    }, [])
    
    useEffect(() => {
        if( nestableRef.current !== null ) {
            // could be a string "ALL"/ "NONE", or an array of ids...
            let collapsed = localStorage[collapse_key]
            try {
                collapsed = JSON.parse(collapsed)
            } catch(err) {
                collapsed = "NONE"
            }
            nestableRef.current.collapse(collapsed)
        }
    }, [ nestableRef ])
    
    const addApplicability = (item, model) => {
        const values = [ ...value, model ]
        onChange(values)
    }

    const removeApplicability = (item, model) => {
        const values = [ ...value.filter((v) => v.project_system_model_id !== model.project_system_model_id) ]
        onChange(values)
    }

    const toggleFavourite = (item) => {
        const updated = favourites.includes(item.id)
                      ? favourites.filter((id) => id !== item.id)
                      : [ ...favourites, item.id ]
        setFavourites(updated)
        localStorage[favourites_key] = JSON.stringify(updated)
    }
    
    const renderProductTreeSystem = ({ item, collapseIcon }) => {
        // Models can only be fixed (not removable) for the Project
        let psm = item.project_system_models.map((v) => {
            let copy = {...v}
            copy.isFixed = false
            return copy
        })
        // Just get the ones that exist in this tree node
        const tree_values = value.filter((v) => v.project_system_id === item.id)

        const selectedSystemId = value.length > 0 ? value[0].project_system_id : null
        const isSystemDisabled = onlyAllowOneSystem && selectedSystemId !== null && selectedSystemId !== item.id

        let buttons = psm.map((i) => {
            if( tree_values.some((v) => v.model_id === i.model_id ) ) {
                return (
                    <button key={i.value} type="button" className="btn btn-xs applicability-button applicability-included"  onClick={() => removeApplicability(item, i)}>{i.value}</button>
                )
            } else {
                if (isSystemDisabled) {
                    return (
                        <button key={i.value} type="button" className="btn btn-xs applicability-button applicability-excluded applicability-button-disabled" disabled={true}>{i.value}</button>
                    )
                }
                return (
                    <button key={i.value} type="button" className="btn btn-xs applicability-button applicability-excluded" onClick={() => addApplicability(item, i)}>{i.value}</button>
                )
            }
        })

        if( disabled ) {
            // Only show included models, not clickable
            buttons = psm.map((i) => {
                if( tree_values.some((v) => v.model_id === i.model_id ) ) {
                    return (
                        <button key={i.value} type="button" className="btn btn-xs applicability-button applicability-included applicability-button-disabled" disabled={true}>{i.value}</button>
                    )
                } else {
                    return null
                }
            })
        }
        
        const favourite = favourites.includes(item.id)
                        ? (
                            <button type="button" className="btn btn-xs btn-toggle-favourite" onClick={() => toggleFavourite(item)}>
                                <i className="fa fa-star"></i>
                            </button>
                        )
                        : (
                            <button type="button" className="btn btn-xs btn-toggle-favourite" onClick={() => toggleFavourite(item)}>
                                <i className="fa fa-star grey"></i>
                            </button>
                        )

        let containerClassName = "applicability-container"
        if( showOnlyFavourites && ! favourites.includes(item.id) ) {
            containerClassName += " hidden"
        }

        return (
            <div className={containerClassName}>
                <div className="applicability-system-name">
                    <span className="applicability-collapse">{collapseIcon}</span>
                    {item.name}
                </div>
                <div className="applicability-buttons">
                    {buttons}
                </div>
                <div className="applicability-favourite">
                    {favourite}
                </div>
            </div>
        )
    }

    const setProductTreeCollapse = (value) => {
        localStorage[collapse_key] = value
        if( nestableRef.current !== null ) {
            nestableRef.current.collapse(value)
        }
    }

    const expandAll = () => {
        setProductTreeCollapse("NONE")
    }
    
    const collapseAll = () => {
        setProductTreeCollapse("ALL")
    }

    const onCollapseChange = ({ closedIds }) => {
        setProductTreeCollapse(JSON.stringify(closedIds))
    }

    const selectView = (view, onlyFavs) => {
        setShowOnlyFavourites(onlyFavs)
        setView(view)
        localStorage[favourites_only_key] = JSON.stringify(onlyFavs)
        localStorage[view_key] = view
    }
    
    const selectTreeView = () => {
        selectView("tree", false)
    }
    const selectListView = (e) => {
        selectView("list", false)
    }
    const selectListFavouritesView = () => {
        selectView("list_favourites", true)
    }

    const treeView = () => {
        // Instead of nulling this, hide it it it's irrelevant. That way its state is kept
        //if( view !== "tree") { return null }
        const className = view === "tree" ? "" : "hidden"

        return (
            <Nestable
                className={className}
                ref={nestableRef}
                onCollapseChange={onCollapseChange}
                disableDrag={true}
                disableCollapse={false}
                items={options}
                renderCollapseIcon={(item) => item.isCollapsed
                                          ? (<i className="fa fa-caret-right" aria-hidden="true"></i>)
                                          : (<i className="fa fa-caret-down" aria-hidden="true"></i>)
                                   }
                renderItem={(item) => renderProductTreeSystem(item)}
            />
        )
    }

    const listView = () => {
        if( view !== "list") { return null }
        
        return (
            <Nestable
                className="nestable-flat"
                onCollapseChange={onCollapseChange}
                disableDrag={true}
                disableCollapse={true}
                items={options}
                renderCollapseIcon={() => null}
                renderItem={(item) => renderProductTreeSystem(item)}
            />
        )
    }
    
    const listFavouritesView = () => {
        if( view !== "list_favourites") { return null }

        if( favourites.length === 0 ) {
            return (
                <div>
                    You have not selected any favourite items.
                    In one of the other views, click <i className="fa fa-star"></i> on the items you would like to add to this view.
                </div>
            )
        }
        
        return (
            <Nestable
                className="nestable-flat"
                onCollapseChange={onCollapseChange}
                disableDrag={true}
                disableCollapse={true}
                items={options}
                renderCollapseIcon={() => null}
                renderItem={(item) => renderProductTreeSystem(item)}
            />
        )
    }

    const viewButton = (type, text, onClick) => {
        const selected = type === view ? " selected" : ""
        const className = "btn btn-white btn-xs"+selected
        return (
            <button type="button" className={className} onClick={onClick}>
                <span dangerouslySetInnerHTML={{__html: text}}></span>
            </button>
        )
    }

    const collapseButtons = () => {
        if( view !== "tree") { return null }
        
        return (
            <div className="btn-group">
                <button type="button" className="btn btn-white btn-xs" onClick={expandAll}>
                    Expand All
                </button>
                <button type="button" className="btn btn-white btn-xs" onClick={collapseAll}>
                    Collapse All
                </button>
            </div>
        )
    }

    if( projectType === "Opportunity" ) {
        return null
    }
    
    if( options.length === 0 ) {
        return (
            <div>
            <div className="form-group">
                <label className="col-sm-2 control-label">{label}
                    <br/><small style={{fontWeight: "normal"}}>{subLabel}</small>
                </label>
                <div className="col-sm-8">
                    <div className="form-text stonly applicability-intro">
                        {noOptionsText}
                    </div>
                    
                    <div className="form-text">
                        &nbsp;
                    </div>
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            </div>
        )
    }
    
    return (
        <div>
        <div className="form-group">
            <label className="col-sm-2 control-label">{label}
                <br/><small style={{fontWeight: "normal"}}>{subLabel}</small>
            </label>
            <div className="col-sm-8">
                <div className="form-text stonly applicability-intro">
                    {introText}
                </div>
                
                <div className="form-text">
                    &nbsp;
                </div>
                
                <div className="applicability-controls">
                    <div className="applicability-controls--view">
                        <div className="btn-group">
                            {viewButton("tree", "Tree view",selectTreeView)}
                            {viewButton("list", "List view",selectListView)}
                            {viewButton("list_favourites", 'List only <i class="fa fa-star"></i>',selectListFavouritesView)}
                        </div>
                    </div>
                    <div className="applicability-controls--collapse">
                        {collapseButtons()}
                    </div>
                </div>

                {treeView()}
                {listView()}
                {listFavouritesView()}
            </div>
        </div>
        <div className="hr-line-dashed"></div>
        </div>
    )
}

export default Applicability
